import React, { useEffect } from "react";
import useVideoJS from "./useVideo.js";

function VideoPlayer(props) {
  const { videoUrl } = props;
  const { sections } = props;
  const { idCurrentVideo } = props;
  const { prevVideo, nextVideo } = props;
  const { nextSection } = props;
  const { autoAdvanceVideo, previousVideo } = props;
  const { videoSlug, location } = props;
  const { handleChangeVideoPath } = props;
  // const { changes, calculeProgress } = props;

  useEffect(() => {
    handleChangeVideoPath(videoSlug, sections);
  }, [location.pathname, handleChangeVideoPath, sections, videoSlug]);

  const player = useVideoJS({
    autoplay: true,
    controls: true,
    sections,
    idCurrentVideo,
    autoAdvanceVideo,
    previousVideo,
    prevVideo,
    nextVideo,
    nextSection,
    videoUrl
    // changes,
    // calculeProgress,
  });

  return <>{player}</>;
}

export default VideoPlayer;
